import HomeMenuComponent from '@/components/home-menu/home-menu.component';
import { INivel } from '@/shared/insaculacion/entity-commons/entity.factory';
import { EstadoRevision } from '@/shared/model/enumerations/estado-revision.model';
import { NRecomendadoEnum } from '@/shared/model/enumerations/nivel-recomendado-enum.model';
import { TipoGenero } from '@/shared/model/enumerations/tipo-genero-enum.model';
import { Dictamen } from '@/shared/model/respuesta.model';
import { IRevision, Revision } from '@/shared/model/revision.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { mixins } from 'vue-class-component';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import { mapGetters, mapMutations } from 'vuex';

const validations: any = {
  dictamenEmerito: {
    comentarios: {
      required,
      min: minLength(500),
      max: maxLength(4000),
    },
  },
};

@Component({
  validations,
  computed: {
    ...mapGetters(['dictamen', 'evaluacion', 'revisorSeleccionado']),
  },
  methods: {
    ...mapMutations(['setDictamen', 'setEvaluacion']),
  },
})
export default class DictamenEmeritos2026Component extends mixins(HomeMenuComponent) {
  @Prop({ required: true })
  public solicitud: Solicitud;

  @Prop({ required: true })
  public revision: Revision;

  /**
   * Indica si se requiere una evaluación individual.
   */
  @Prop({ required: false, default: true })
  public evaluacionIndividual: boolean;

  public valueEmerito: boolean | null = null;

  // public dictamenEmerito: any = {};

  public dictamenEmerito: Dictamen = {
    comentarios: '',
  };

  public aceptada = EstadoRevision.ACEPTADA;
  public revisada = EstadoRevision.REVISADA;

  public caracterInicial = 0;
  public caracteresFaltantes = 139;
  public caracteresMinimos = 500;
  public caracteresMaximos = 4000;

  public idNivelEmerito = NRecomendadoEnum.NIVEL_EMERITO;

  public Masculino = TipoGenero.MASCULINO;

  public Femenino = TipoGenero.FEMENINO;

  public revisiones: Array<IRevision> = [];

  setDictamen!: (dictamen: Dictamen) => void;

  setEvaluacion!: (evaluacion: INivel) => void;

  public readonly dictamen: Dictamen;

  public readonly evaluacion: INivel;

  public readonly revisorSeleccionado: number;

  mounted(): void {
    this.get();
  }

  public get(): void {
    if (this.solicitud && this.revision) {
      if (this.revision?.respuesta?.dictamen) {
        this.dictamenEmerito = this.revision.respuesta.dictamen;
      } else if (this.dictamen && this.revision?.respuesta?.evaluacion) {
        this.dictamenEmerito = this.dictamen;
        this.revision.respuesta.evaluacion = this.evaluacion;
      } else if (!this.evaluacionIndividual) {
        this.dictamenEmerito = this.dictamen;
        this.revision.respuesta.evaluacion = this.evaluacion;
      }
      if (this.revision?.respuesta?.evaluacion?.id) {
        this.valueEmerito = this.revision.respuesta.evaluacion.id === this.idNivelEmerito;
      } else {
        this.valueEmerito = null;
      }
    }
  }

  public get evaluacionDictamen(): INivel {
    const respuesta: any = this.revision?.respuesta;
    const properties: any = respuesta?.properties || respuesta || {};

    return properties?.evaluacion || this.evaluacion || {};
  }

  public get esNoAprobado(): boolean {
    return String(this.evaluacionDictamen?.id || '') === '5';
  }

  public get esAprobado(): boolean {
    return String(this.evaluacionDictamen?.id || '') === '6';
  }

  public get descripcionComprensibleDictamen(): string {
    const respuesta: any = this.revision?.respuesta;
    const properties: any = respuesta?.properties || respuesta || {};

    return properties?.resultadoGralCualitativoFinal || '_____';
  }

  public get valoracionesCualitativasDictamen(): any {
    const respuesta: any = this.revision?.respuesta;
    const properties: any = respuesta?.properties || respuesta || {};

    return properties?.valoracionesCualitativasEme || {};
  }

  public get hayValoracionesCualitativasDictamen(): boolean {
    return Object.keys(this.valoracionesCualitativasDictamen || {}).length > 0;
  }

  public get filasValoracionCualitativaDictamen(): any[] {
    const valoraciones = this.valoracionesCualitativasDictamen;

    const filas = [
      {
        componente: 'Componente 1. Producción científica, humanística y tecnológica',
        cualidad: 'Relevante',
        campo: 'relevante',
      },
      {
        componente: 'Componente 1. Producción científica, humanística y tecnológica',
        cualidad: 'Pertinente',
        campo: 'pertinente',
      },
      {
        componente: 'Componente 1. Producción científica, humanística y tecnológica',
        cualidad: 'Sostenida',
        campo: 'sostenida',
      },
      {
        componente: 'Componente 1. Producción científica, humanística y tecnológica',
        cualidad: 'Diversa',
        campo: 'diversa',
      },
      {
        componente: 'Componente 2. Fortalecimiento y Consolidación de la Comunidad',
        cualidad: 'Comprometido con la formación',
        campo: 'comprometidoFormacion',
      },
      {
        componente: 'Componente 2. Fortalecimiento y Consolidación de la Comunidad',
        cualidad: 'Colaborativo',
        campo: 'colaborativo',
      },
      {
        componente: 'Componente 2. Fortalecimiento y Consolidación de la Comunidad',
        cualidad: 'Constante',
        campo: 'constante',
      },
      {
        componente: 'Componente 3. Divulgación',
        cualidad: 'Inclusiva y gratuita',
        campo: 'inclusivaGratuita',
      },
      {
        componente: 'Componente 3. Divulgación',
        cualidad: 'Comprensible',
        campo: 'comprensible',
      },
    ];

    return filas.map(fila => {
      const valoracion = valoraciones?.[fila.campo];

      return {
        ...fila,
        descripcion: valoracion?.descripcion || 'Sin valoración',
        valor: valoracion?.valor ?? '—',
      };
    });
  }

  /**
   * Este método emite un evento para guardar sobre el cambio
   * de la variable valido.
   *
   * @memberof DictamenEmeritosComponent
   */
  public toggleRadioButton(): void {
    const datosEnviar = { valido: false };
    this.$emit('guardarDictamenEmerito', datosEnviar);
  }

  public guardarDictamen0(): void {
    let idEvaluacion;
    let nombreEvaluacion;
    this.setEvaluacion({});
    this.setDictamen({});
    if (this.valueEmerito) {
      idEvaluacion = NRecomendadoEnum.NIVEL_EMERITO;
      nombreEvaluacion = this.$t('dictamenEmeritos.emeritoAprobado');
    } else {
      idEvaluacion = NRecomendadoEnum.NO_APROBADO;
      nombreEvaluacion = this.$t('dictamen.noAprobado');
    }

    const dictamenEmerito = {
      evaluacion: {
        id: idEvaluacion,
        nombre: nombreEvaluacion,
      },
      dictamen: {
        comentarios: this.dictamenEmerito.comentarios,
      },
      valido: true,
    };

    this.$emit('guardarDictamenEmerito', dictamenEmerito);
  }

  public limitarComentariosDictamenNegativo(): void {
    const comentario = this.dictamenEmerito?.comentarios || '';

    if (comentario.length > this.caracteresMaximos) {
      this.dictamenEmerito.comentarios = comentario.substring(0, this.caracteresMaximos);
    }
  }

  public tocarComentariosDictamenNegativo(): void {
    this.$v?.dictamenNegativo?.comentarios?.$touch();
  }

  public guardarDictamen(): void {
    this.$v?.$touch();

    const respuesta: any = this.revision?.respuesta || {};
    const propertiesActuales: any = respuesta?.properties || respuesta || {};

    const dictamenEnviar = {
      comentarios: this.dictamenEmerito?.comentarios || '',
    };

    const evaluacionEnviar = this.evaluacionDictamen;

    this.setEvaluacion(evaluacionEnviar);
    this.setDictamen(dictamenEnviar as Dictamen);

    const dictamen2026 = {
      ...propertiesActuales,
      evaluacion: evaluacionEnviar,
      dictamen: dictamenEnviar,
      valido: true,
    };

    this.$emit('guardarDictamenEmerito', dictamen2026);
  }

  get comentarioDictamenNegativoRequerido(): boolean {
    const campo = this.$v?.dictamenEmerito?.comentarios;

    return campo?.$dirty && !campo?.required;
  }

  get comentarioDictamenNegativoMinimo(): boolean {
    const campo = this.$v?.dictamenEmerito?.comentarios;

    return campo?.$dirty && !campo?.min;
  }

  get comentarioDictamenNegativoMaximo(): boolean {
    const campo = this.$v?.dictamenEmerito?.comentarios;

    return campo?.$dirty && !campo?.max;
  }

  get caracteresComentarioDictamenNegativo(): number {
    return Number(this.dictamenEmerito?.comentarios?.length || 0);
  }

  get caracteresFaltantesDictamenNegativo(): number {
    const faltantes = this.caracteresMinimos - this.caracteresComentarioDictamenNegativo;

    return faltantes > 0 ? faltantes : 0;
  }

  get habilitarSave(): boolean {
    return this.esAprobado || (this.esNoAprobado && (this.dictamenEmerito?.comentarios?.length ?? 0) >= 500);
  }
}
